import * as React from "react";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";
import { FeedbackForm } from "./FeedbackForm";
import { RoadmapView } from "./RoadMapView";
import { NoticeView } from "./NoticeView";
import { MyTicketsView } from "./MyTicketView";
import { Button } from "../ui/button";

export function FeedbackSidebar({ isOpen, onClose, onSubmit }) {
  const [activeTab, setActiveTab] = React.useState("newTicket");
  const sidebarRef = React.useRef(null);

  const tabs = [
    { value: "newTicket", label: "New Ticket" },
    { value: "myTickets", label: "My Tickets" },
    { value: "roadmap", label: "Roadmap" },
    { value: "notice", label: "Notice" },
  ];

  React.useEffect(() => {
    const handleOutsideClick = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  return (
<div
  ref={sidebarRef}
  className={
    "z-[100] fixed inset-y-0 right-0 bg-white border-l shadow-lg w-full md:w-[400px] transform transition-transform duration-300 ease-in-out " +
    (isOpen ? "translate-x-0" : "translate-x-full")
  }
>
  <div className="flex h-full flex-col">
    {/* 헤더 영역 */}
    <div className="bg-white border-b p-4 flex justify-between items-center">
      <h2 className="text-xl font-semibold">Feedback</h2>
      <Button variant="ghost" size="icon" onClick={onClose}>
        <X className="h-5 w-5" />
      </Button>
    </div>

    {/* 탭 버튼 영역 */}
    <div className="border-b overflow-x-auto scrollbar-hide">
      <div className="flex px-4 min-w-max">
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            className={
              "px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap " +
              (activeTab === tab.value
                ? "border-b-2 border-primary text-primary"
                : "text-muted-foreground hover:text-foreground")
            }
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>

    {/* 컨텐츠 영역 */}
    <div className="flex-1 overflow-auto p-4 md:p-6">
      {activeTab === "newTicket" && <FeedbackForm onSubmit={onSubmit} />}
      {activeTab === "myTickets" && <MyTicketsView />}
      {activeTab === "roadmap" && <RoadmapView />}
      {activeTab === "notice" && <NoticeView />}
    </div>
  </div>
</div>
  );
}
